var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-link",class:_vm.classes},[_c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"app-link__self"},'component',_vm.attributes,false),_vm.listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }